var _circle, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.1818,
    cy: 68.1818,
    r: 68.1818,
    fill: "#ECEFF1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 85,
    height: 85,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3815_587",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3815_587",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEeUlEQVR4nO2bz24TVxTGP49jVBXYFHb0BborXfDnPVDbt+gOaEXiLkgTpKYNKTSChNxrKoQURekm24pNXwC1SkhbKQGMFEQcJBAiThpOdccTGv8Zx/bc8YzvfD/pbGJnHH/f3HPPuXMCEEIIIYQQQgghhBBiESnCkxLOi8bXorAoCn+IwpYo7AaxFfzMvHZZFM6Z36EJUYX/BR+LwrgoPBUN6TKeiMaYaJyiEd0Kfw8nRWNaFKo9CC91Ya6h8LOUcIJGdCK+wpeiUYksvG6KipTwBU0IE/4BhkTjVgzCS0NMm8+iEQfFv4UPRWOpD+JLEEvmM2mCEX8eedH4tY/iy3sTuBKAPqUdCUtHmV4FwYYbJs62aFwXjTNyF0eDOCsaU8FrYik+R4ZLzdbVjkJZFD4N/d0STvvv0RYMUNjMZInqVyOtRXnbTvw6E7SllaBwExnscMOarKmOr6PwkyUDqpnqmP3jhXBBznRxnXMW94IxZOZgrd3Zzl0c7fha8zhm0YAnmTjAC041w4WYx7GOrzWL4xYNMOafhev4x8WWRBC7KcjsBRfhOv6ZfXsh+r8J6/exANfxH5y0F2HblJiHXmcOn1luyMwKeAjX8Z9eHS5EuZ0Jvvi2GjFd97mbcJ0uHrJs+ynG5Pn9o4jaBn7DyoMa3dKAKlxHNHZiEU/TAHspKDkDNuE6ovBnig14CNfpoAxNMhaArDdiycYluI717lXbi40Jb1XmcQQuI4KcaKwnLbY0RPV2TpavFGT9av7xmsIHcJlgYk3SFC9+8HwDTDweza85vRLMw4/YmindfewpyF/Fmvj7sTXp/e701IQ/LpgC8UVDKpP/3/0mVosF2ZvzX7vvrAkyg49E4UXS4u/OQh6N1N/9zyfyB9/jsAkaF5I2YH00X3/3jxTk3ztN73PahLDpiNhjY6Je/JoBQ7Izm2v1fjdN8EcTE+iOX9/MyfJwvfj78fe3Q7IzkyUT+jyc++qGJysNeZ8m1MbTp/tS8QzXC75Sq/07N0Gh5OwEhZnV9McFLQu/ewfydKxZZL/mv+4ZUeXZtS5McDUdGcysphkXtNGs7anaXW+qm0ZxV4YL8nLKO3hn04QWHfN48A93XQlfncn5xwuNHe5+mNrfbMQt0gtNaDlNZ0bTFS6aM3vz4CSYrN4JohL8bMEcKW987y2322DXroaWmjTBSgorYmh9NP9PU41fLEjlR0/eqQ5WEVeCPRNWR2rHCy06XJoQtwmbk96D4GCtt+BKsDKNrSNVUzSBJgw8wpUwGAjTUcoN0NwTkjdA04TkDdA0IRZYoiaMsE8YQAM005E12DGnHOFKSLkBmukoVmLcE1S8f7kjSJwbcwmfJP39Uo/EWx1dSfr7pR6Js0TNwj8Jpr5PYBpKvE9gGopCZBOYhqJhZSUwDfWOjXT0Zjo3EeFPyDbSxZ5gBsTK480mlK95i0l/j4FFIm7M5e+835L+DgONRKiOyuMUPzI9l6hz+Cb6pxP0cPe/E42vKB0hhBBCCCGEEEIIIYSgDf8BmXgOPamOr7wAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey2);
export default __webpack_public_path__ + "static/media/key2.20ec66b64c1108d15d300d8b674dd9ec.svg";
export { ForwardRef as ReactComponent };